import * as React from "react";
import { forwardRef } from "react";
const SvgNone = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 23, viewBox: "0 0 30 116", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("line", { x1: 14.5, y1: 115.039, x2: 14.5, y2: -610352e-10, stroke: "black", strokeWidth: 7 }), /* @__PURE__ */ React.createElement("rect", { y: 97, width: 30, height: 6, fill: "white" }));
const ForwardRef = forwardRef(SvgNone);
export default ForwardRef;
